import React from 'react';
import { useLogger } from 'logging/writers/hooks';
import { useIndigoWithOpenFin } from './useIndigoWithOpenFin';

export const usingOpenFin = typeof fin !== 'undefined';

export function OpenFinSupport() {
    const logger = useLogger('OpenFinSupport');

    logger.info(usingOpenFin ? 'Using OpenFin' : 'Not using OpenFin');

    if (usingOpenFin) {
        return <OpenFinContent />;
    }

    return <></>;
}

export function OpenFinContent() {
    useIndigoWithOpenFin();
    return <></>;
}
